import Moment from "moment";
import { extendMoment } from "moment-range";
import FetchClients from "../client";
import { useQuery as useReactQuery } from "@tanstack/react-query";
import {
  bugsnagGeneralErrorHandler,
  recursiveCamelCaseCipherTypesafe,
} from "@src/global_functions/postgrestApi";
const moment = extendMoment(Moment);

const reasonsForNoScore = {
  useGetReasonsForNoScore,
  useGetMissingMonths,
} as const;
export default reasonsForNoScore;

const getReasonsForNoScore = async (siteId: number, missingBills: boolean) => {
  const { data, error } = await FetchClients.site.GET(
    "/{site_id}/main_linked_es_property/reasons_for_no_score",
    {
      params: {
        query: {
          missing_bills: missingBills,
        },
        path: {
          site_id: siteId,
        },
      },
    }
  );
  if (data) return recursiveCamelCaseCipherTypesafe(data);
  throw new Error(error);
};

function useGetReasonsForNoScore(siteId: number) {
  return useReactQuery({
    queryKey: ["reasons-for-no-score", siteId],
    queryFn: () => getReasonsForNoScore(siteId, false),
  });
}

const HAS_NO_METERS_ALERT_NAME = "Property has no energy meters.";
function useGetMissingMonths(siteId: number) {
  return useReactQuery({
    queryKey: ["reasons-for-no-score-missing-months", siteId],
    queryFn: () => getReasonsForNoScore(siteId, true),
    select: (data) => {
      return data.reduce(
        (acc, reason) => {
          if (reason.name === HAS_NO_METERS_ALERT_NAME) {
            return {
              ...acc,
              hasMeters: false,
            };
          }
          if (reason.description) {
            try {
              for (const [, startDate, endDate] of reason.description.matchAll(
                /\(missing bills for ([0-9/]*) - ([0-9/]*)\)/g
              )) {
                const range = moment.range(
                  moment(startDate, "MM/DD/YYYY"),
                  moment(endDate, "MM/DD/YYYY")
                );
                return {
                  ...acc,
                  missingMonths: [
                    ...acc.missingMonths,
                    ...Array.from(range.by("month")),
                  ],
                };
              }
            } catch (e) {
              bugsnagGeneralErrorHandler(e);
            }
          }
          return acc;
        },
        { hasMeters: true, missingMonths: [] } as {
          hasMeters: boolean;
          missingMonths: Moment.Moment[];
        }
      );
    },
  });
}
